module.exports = __webpack_public_path__ + "static/media/results-astro.437a94fa.gif";